import React, {useState} from 'react';

import './Navbar.scss';

import {motion} from "framer-motion";

//icons
import {HiMenuAlt4, HiX} from 'react-icons/hi'

//assets
import {images} from '../../constants';
import Cv from "../cv";

const Navbar = ({setIsActive}) => {

    const items = ["home", "about", "work", "skills", "contact",]

    //states
    const [toggle, setToggle] = useState(false)


    return (
        <nav className="app__navbar">
            <div className="app__navbar-logo">
                <h3>Maha<span>med</span></h3>
                {/** <img src={images.logo} alt={"logo"}/>*/}
            </div>
            <ul className="app__navbar-links">
                {items.map((item) => (
                    <li key={`link-${item}`} className="app__flex p-text">
                        <div/>
                        <a href={`#${item}`}>{item}</a>
                    </li>
                ))}
            </ul>
            <div className="app__navbar-menu">
                <HiMenuAlt4 onClick={() => setToggle(true)}/>
                {
                    toggle && (
                        <motion.div
                            whileInView={{x: [200, 0]}}
                            transition={{duration: 0.85, ease: 'easeOut'}}
                        >
                            <HiX onClick={() => setToggle(false)}/>
                            <ul className="app__navbar-links">
                                {items.map((item) => (
                                    <li key={item} onClick={() => setToggle(false)}>
                                        <a href={`#${item}`}>{item}</a>
                                    </li>
                                ))}
                                     
                               
                            </ul>


                        </motion.div>
                    )
                }
            </div>

        </nav>
    )
}
export default Navbar;
